export const ImageFilenames = {
  genericPublicLink: {
    landingPageImage: '',
  },
};
